import {SESSION_ID_KEY} from '@src/Providers/SessionProvider/useSessionId';
import axios from 'axios';
import apiConfig from '~Configs/apiConfig';

export const traceAxiosInstance = axios.create({
  baseURL: apiConfig.traceApiUrl,
  headers: {},
});

// Add a request interceptor to add the sessionId to the request headers
traceAxiosInstance.interceptors.request.use(config => {
  const sessionId = localStorage.getItem(SESSION_ID_KEY);
  if (sessionId) {
    config.headers['x-session-id'] = sessionId;
  }
  return config;
});
